






















































import Vue from 'vue';

export default Vue.extend({
  props: {
    showIf: Boolean,
    mediaSrc: String,
    cardStyle: Object,
    mediaStyle: String,
    drillMovie: Boolean,
    blurImage: Boolean,
  },
  computed: {
    emptyImageOrIntro(): string {
      return 'img/empty.png';
    },
    mediaImageStyle(): string {
      let result = `background: url(${this.mediaSrc}) center center / cover no-repeat;`;
      if (this.$store.getters.isLandscape) {
        if (this.$vuetify.breakpoint.xs) {
          result += 'width: 50%;';
        } else if (this.$vuetify.breakpoint.sm) {
          result += 'width: 70%;';
        } else {
          result += 'width: 100%;';
        }
        result += 'height: 100%;';
      } else {
        result += 'width: 100%;';
        if (this.$vuetify.breakpoint.xs) {
          result += 'height: 70%;';
        } else {
          result += 'height: 100%;';
        }
      }
      if (this.blurImage) {
        result += '-webkit-filter: blur(15px);\n'
          + '  -moz-filter: blur(15px);\n'
          + '  -o-filter: blur(15px);\n'
          + '  -ms-filter: blur(15px);\n'
          + '  filter: blur(15px);';
      }
      return result;
    },
  },
});
